import { BottomTabItem } from './item';
import { BottomTabRoot } from './root';

export const BottomTab = {
  Root: BottomTabRoot,
  Item: BottomTabItem,
};
